import React, { useState } from 'react';
import './ResultAnalysis1.css';
import Navbar from '../components/navbar';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

const ResultAnalysis1 = () => {
  const defaultGraphImg = "/Examination/ResultAnalysis.jpg";

  const topperMeta = {
    semI: { title: 'SEMESTER - I TOPPERS', badge: 'SEM I', theme: 'blue', nameColor: 'var(--ra-primary)' },
    semII: { title: 'SEMESTER - II TOPPERS', badge: 'SEM II', theme: 'green', nameColor: 'var(--ra-success)' },
    semIII: { title: 'SEMESTER - III TOPPERS', badge: 'SEM III', theme: 'green', nameColor: 'var(--ra-success)' },
    semIV: { title: 'SEMESTER - IV TOPPERS', badge: 'SEM IV', theme: 'blue', nameColor: 'var(--ra-primary)' },
    semV: { title: 'SEMESTER - V TOPPERS', badge: 'SEM V', theme: 'green', nameColor: 'var(--ra-success)' },
    semVI: { title: 'SEMESTER - VI TOPPERS', badge: 'SEM VI', theme: 'blue', nameColor: 'var(--ra-primary)' },
  };

  // Complete Centralized Data Structure mapped to the provided text
  const resultData = {
    "2023-24": {
      breadcrumb: "2023-24",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2023 (Dec '23) Examination",
          rows: [
            { semester: "SEMESTER - I (2 yr course)", appeared: 189, passed: 108, percent: 57.14 },
            { semester: "SEMESTER - III (2 yr course)", appeared: 180, passed: 154, percent: 85.56 }
          ],
          overall: 70.73,
          passPercent: 70.73
        },
        firstHalf: {
          title: "First Half 2024 (Jun '24) Examination",
          rows: [
            { semester: "SEMESTER - II (2 yr course)", appeared: 189, passed: 147, percent: 77.77 },
            { semester: "SEMESTER - IV (2 yr course)", appeared: 182, passed: 179, percent: 98.35 }
          ],
          overall: 87.87,
          passPercent: 87.87
        }
      },
      toppers: {
        semI: [
          { rank: 1, name: "Kotre Siddhi Santosh", sgpi: 9.67, batch: "Dec 2023 Exam" },
          { rank: 2, name: "Gupta Jyoti Chandrakant", sgpi: 9.57, batch: "Dec 2023 Exam" },
          { rank: 3, name: "Patel Ashish Ramapati", sgpi: 9.52, batch: "Dec 2023 Exam" }
        ],
        semII: [
          { rank: 1, name: "Gupta Jyoti Chandrakant Geetadevi", sgpi: 9.36, batch: "June 2024 Exam" },
          { rank: 2, name: "Kotre Siddhi Santosh Samiksha", sgpi: 9.32, batch: "June 2024 Exam" },
          { rank: 3, name: "Kolambkar Jayesh Milind Archana", sgpi: 9.28, batch: "June 2024 Exam" }
        ],
        semIII: [
          { rank: 1, name: "Muskan Akbar Ali Gulnaz", sgpi: 9.29, batch: "Dec 2023 Exam" },
          { rank: 2, name: "Gala Jinal Pravin Manju", sgpi: 9.0, batch: "Dec 2023 Exam" },
          { rank: 3, name: "Kewat Neelu Bhagirathi Sushila", sgpi: 8.95, batch: "Dec 2023 Exam" }
        ],
        semIV: [
          { rank: 1, name: "Gala Jinal Pravin Manju", sgpi: 9.44, batch: "June 2024 Exam" },
          { rank: 2, name: "Muskan Akbar Ali Gulnaz", sgpi: 9.41, batch: "June 2024 Exam" },
          { rank: 3, name: "Kewat Neelu Bhagirathi Sushila", sgpi: 9.09, batch: "June 2024 Exam" }
        ]
      },
      summary: {
        batch: "BATCH 2022-2024",
        percentage: 94.79,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          graduatingBatch: "BATCH 2022-2024",
          successfulGraduates: 173,
          firstDivisionGraduates: 164,
          percentage: 94.79
        }
      ],
      graphTitle: "Result Analysis Graph for Batch 2022-24",
      graphImg: "/Examination/Result-Analysis-Batch-22-24.jpg"
    },
    "2022-23": {
      breadcrumb: "2022-23",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2022 (Dec '22) Examination",
          rows: [
            { semester: "SEMESTER - I (2 yr course)", appeared: 188, passed: 106, percent: 56.38 },
            { semester: "SEMESTER - III (2 yr course)", appeared: 185, passed: 133, percent: 71.89 }
          ],
          overall: 64.08,
          passPercent: 64.08
        },
        firstHalf: {
          title: "First Half 2023 (Jun '23) Examination",
          rows: [
            { semester: "SEMESTER - II (2 yr course)", appeared: 188, passed: 157, percent: 84.04 },
            { semester: "SEMESTER - IV (2 yr course)", appeared: 185, passed: 183, percent: 98.91 }
          ],
          overall: 91.15,
          passPercent: 91.15
        }
      },
      toppers: {
        semI: [
          { rank: 1, name: "Muskan Akbar Ali Gulnaz", sgpi: 9.62, batch: "DEC 2022 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Jain Shreya Mahendra Alka", sgpi: 9.33, batch: "DEC 2022 Exam", universityRank: 5, instituteRank: 2 },
          { rank: 3, name: "Yadav Priyanka Kapildev Usha", sgpi: 9.05, batch: "DEC 2022 Exam", universityRank: 11, instituteRank: 3 }
        ],
        semIII: [
          { rank: 1, name: "Shahu Pooja Jitendra", sgpi: 9.85, batch: "DEC 2022 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Singh Lacky Shivkumar", sgpi: 9.4, batch: "DEC 2022 Exam", universityRank: 4, instituteRank: 2 },
          { rank: 2, name: "Singh Sheetal Mahendra", sgpi: 9.4, batch: "DEC 2022 Exam", universityRank: 4, instituteRank: 2 },
          { rank: 3, name: "Lohia Ayushi Sundeep", sgpi: 9.35, batch: "DEC 2022 Exam", universityRank: 5, instituteRank: 3 },
          { rank: 4, name: "Kanojiya Hritik Rajdev", sgpi: 9.25, batch: "DEC 2022 Exam", universityRank: 6, instituteRank: 4 },
          { rank: 5, name: "Gupta Vandana Jaigurudev", sgpi: 9.1, batch: "DEC 2022 Exam", universityRank: 8, instituteRank: 5 }
        ]
      },
      summary: {
        batch: "BATCH 2021-2023",
        percentage: 81.76,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          graduatingBatch: "BATCH 2021-2023",
          successfulGraduates: 170,
          firstDivisionGraduates: 139,
          percentage: 81.76
        }
      ],
      graphTitle: "Result Analysis Graph for Batch 2021-23",
      graphImg: "/Examination/Graph-2023-25.jpeg"
    },
    "2021-22": {
      breadcrumb: "2021-22",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2021 (Dec '21) Examination",
          rows: [
            { semester: "SEMESTER - I (2 yr course)", appeared: 189, passed: 185, percent: 97.88 },
            { semester: "SEMESTER - III (2 yr course)", appeared: 187, passed: 186, percent: 99.46 },
            { semester: "SEMESTER - V (CBSGS)", appeared: 114, passed: 114, percent: 100.0 }
          ],
          overall: 98.96,
          passPercent: 98.96
        },
        firstHalf: {
          title: "First Half 2022 (July '22) Examination",
          rows: [
            { semester: "SEMESTER - II (CBCGS) (2 yr course)", appeared: 189, passed: 179, percent: 94.71 },
            { semester: "SEMESTER - IV (CBCGS) (2 yr course)", appeared: 187, passed: 184, percent: 98.39 },
            { semester: "SEMESTER - VI (CBSGS) (3 yr course)", appeared: 114, passed: 113, percent: 99.12 }
          ],
          overall: 97.28,
          passPercent: 97.28
        }
      },
      toppers: {
        semII: [
          { rank: 1, name: "Babu Shivani Suresh", sgpi: 9.44, batch: "July 2022 Exam", universityRank: 5, instituteRank: 1 },
          { rank: 1, name: "Shahu Pooja Jitendra", sgpi: 9.44, batch: "July 2022 Exam", universityRank: 5, instituteRank: 1 },
          { rank: 2, name: "Gupta Vandana Jaigurudev", sgpi: 9.28, batch: "July 2022 Exam", universityRank: 7, instituteRank: 2 },
          { rank: 3, name: "Singh Lacky Shivkumar", sgpi: 9.0, batch: "July 2022 Exam", universityRank: 9, instituteRank: 3 }
        ],
        semIV: [
          { rank: 1, name: "Sandhya Santhosh", sgpi: 9.98, batch: "July 2022 Exam", universityRank: 2, instituteRank: 1 },
          { rank: 2, name: "Patil Swapnali Gajanan", sgpi: 9.97, batch: "July 2022 Exam", universityRank: 3, instituteRank: 2 },
          { rank: 3, name: "Maurya Soniya Sureshchandra", sgpi: 9.94, batch: "July 2022 Exam", universityRank: 4, instituteRank: 3 },
          { rank: 4, name: "Shah Malav Chetan", sgpi: 9.93, batch: "July 2022 Exam", universityRank: 5, instituteRank: 4 }
        ],
        semVI: [
          { rank: 1, name: "Shaikh Muskan Sadiq Hafiza", sgpi: 9.74, batch: "July 2022 Exam", universityRank: 5, instituteRank: 1 },
          { rank: 2, name: "Naik Mansi Suhas Sneha", sgpi: 9.38, batch: "July 2022 Exam", universityRank: "-", instituteRank: 2 },
          { rank: 3, name: "Belel Ankita Uttam Anita", sgpi: 9.35, batch: "July 2022 Exam", universityRank: "-", instituteRank: 3 },
          { rank: 4, name: "Angane Rashmi Sunil Smita", sgpi: 9.17, batch: "July 2022 Exam", universityRank: "-", instituteRank: 4 }
        ],
        semI: [
          { rank: 1, name: "Bhawsar Ayushie Rajesh", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Jain Pinal Dinesh", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Babu Shivani Suresh", sgpi: 9.95, batch: "DEC 2021 Exam", universityRank: 2, instituteRank: 2 },
          { rank: 2, name: "Jain Sakshi Laxmilal", sgpi: 9.95, batch: "DEC 2021 Exam", universityRank: 2, instituteRank: 2 },
          { rank: 3, name: "Bawiskar Aboli Ajit", sgpi: 9.9, batch: "DEC 2021 Exam", universityRank: 3, instituteRank: 3 },
          { rank: 3, name: "Dalal Pranali Sunil", sgpi: 9.9, batch: "DEC 2021 Exam", universityRank: 3, instituteRank: 3 },
          { rank: 3, name: "Dsouza Soney Xavier", sgpi: 9.9, batch: "DEC 2021 Exam", universityRank: 3, instituteRank: 3 },
          { rank: 3, name: "Irabatti Shridhar Narsingh", sgpi: 9.9, batch: "DEC 2021 Exam", universityRank: 3, instituteRank: 3 },
          { rank: 3, name: "Kaushik Khushi Pramod", sgpi: 9.9, batch: "DEC 2021 Exam", universityRank: 3, instituteRank: 3 },
          { rank: 4, name: "Dubey Snehal Satish", sgpi: 9.86, batch: "DEC 2021 Exam", universityRank: 4, instituteRank: 4 },
          { rank: 5, name: "Gupta Vandana Jaigurudev", sgpi: 9.81, batch: "DEC 2021 Exam", universityRank: 5, instituteRank: 5 },
          { rank: 5, name: "Kanojiya Hritik Rajdev", sgpi: 9.81, batch: "DEC 2021 Exam", universityRank: 5, instituteRank: 5 }
        ],
        semIII: [
          { rank: 1, name: "Khan Uzma Akbar", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Pandey Himani Gyanprakash", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Patil Mayur Vasant", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Patil Swapnali Gajanan", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Poojari Sushma Sundar", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Sandhya Santhosh", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Sharma Shivam Vijaykumar", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Shah Malav Chetan", sgpi: 9.9, batch: "DEC 2021 Exam", universityRank: 3, instituteRank: 2 },
          { rank: 3, name: "Maurya Soniya Sureshchandra", sgpi: 9.85, batch: "DEC 2021 Exam", universityRank: 4, instituteRank: 3 },
          { rank: 3, name: "Pandey Akhilesh Indradev", sgpi: 9.85, batch: "DEC 2021 Exam", universityRank: 4, instituteRank: 3 },
          { rank: 3, name: "Patil Mansi Jitendra", sgpi: 9.85, batch: "DEC 2021 Exam", universityRank: 4, instituteRank: 3 },
          { rank: 3, name: "Patil Namrata Digambar", sgpi: 9.85, batch: "DEC 2021 Exam", universityRank: 4, instituteRank: 3 },
          { rank: 3, name: "Shaikh Afsha Ashraf", sgpi: 9.85, batch: "DEC 2021 Exam", universityRank: 4, instituteRank: 3 }
        ],
        semV: [
          { rank: 1, name: "Naik Mansi Suhas Sneha", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Shaikh Muskan Sadiq Hafiza", sgpi: 10.0, batch: "DEC 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Belel Ankita Uttam Anita", sgpi: 9.71, batch: "DEC 2021 Exam", universityRank: 4, instituteRank: 2 },
          { rank: 2, name: "Nishad Archana Nagadish Suneeta", sgpi: 9.71, batch: "DEC 2021 Exam", universityRank: 4, instituteRank: 2 },
          { rank: 3, name: "Kawnder Ashwita Ravi Mary", sgpi: 9.61, batch: "DEC 2021 Exam", universityRank: 6, instituteRank: 3 }
        ]
      },
      summary: {
        batch: "BATCH 2019-2022 / BATCH 2020-2022",
        percentage: 97.35,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          graduatingBatch: "BATCH 2019-2022",
          successfulGraduates: 113,
          firstDivisionGraduates: 110,
          percentage: 97.35
        },
        {
          srNo: 2,
          graduatingBatch: "BATCH 2020-2022",
          successfulGraduates: 184,
          firstDivisionGraduates: 184,
          percentage: 100
        }
      ],
      graphTitle: "Result Analysis Graph for Batch 2019-22",
      graphImg: defaultGraphImg
    },
    "2020-21": {
      breadcrumb: "2020-21",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2020 (Dec '20) Examination",
          rows: [
            { semester: "SEMESTER - I (2 yr course)", appeared: 187, passed: 186, percent: 99.46 },
            { semester: "SEMESTER - III (CBCGS)", appeared: 114, passed: 113, percent: 99.12 },
            { semester: "SEMESTER - V (CBSGS)", appeared: 117, passed: 117, percent: 100.0 }
          ],
          overall: 99.52,
          passPercent: 99.52
        },
        firstHalf: {
          title: "First Half 2021 (May-June '21) Examination",
          rows: [
            { semester: "SEMESTER - II (CBCGS)", appeared: 187, passed: 186, percent: 99.46 },
            { semester: "SEMESTER - IV (CBCGS)", appeared: 114, passed: 114, percent: 100.0 },
            { semester: "SEMESTER - VI (CBSGS)", appeared: 117, passed: 117, percent: 100.0 }
          ],
          overall: 99.76,
          passPercent: 99.76
        }
      },
      toppers: {
        semII: [
          { rank: 1, name: "Deore Kartika Mukund", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Puthuparambil Justin Joseph", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Khan Uzma Akbar", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Maurya Soniya Sureshchandra", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Merude Gaurav Deepak", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Patil Namrata Digambar", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Patil Swapnali Gajanan", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Sandhya Santhosh", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Shah Malav Chetan", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Sharma Shivam Vijaykumar", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Srivastava Aditya Rajiv Kumar", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Tiwari Rishabh Pawan", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Trivedi Raj Paresh", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Yadav Neha Rajesh", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 }
        ],
        semIV: [
          { rank: 1, name: "Belel Ankita Uttam Anita", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Naik Mansi Suhas Sneha", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Shaikh Muskan Sadiq Hafiza", sgpi: 9.89, batch: "May-June 2021 Exam", universityRank: 3, instituteRank: 2 },
          { rank: 3, name: "Gadala Ana Prabhudas Esther", sgpi: 9.86, batch: "May-June 2021 Exam", universityRank: 4, instituteRank: 3 }
        ],
        semVI: [
          { rank: 1, name: "Kewat Rahul Chhotelal", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Soni Priya Ajaykumar", sgpi: 10.0, batch: "May-June 2021 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Fernandes Treyhan Kirsten", sgpi: 9.93, batch: "May-June 2021 Exam", universityRank: 2, instituteRank: 2 },
          { rank: 2, name: "Sane Dhanashree Sunil", sgpi: 9.93, batch: "May-June 2021 Exam", universityRank: 2, instituteRank: 2 }
        ],
        semI: [
          { rank: 1, name: "Borekar Ashwini Anmol", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Dubey Ajaykumar Baikunthnath", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Jadhav Nitin Ashok", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Jain Rajul Vinod", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Maurya Soniya Sureshchandra", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Merude Gaurav Deepak", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Patil Swapnali Gajanan", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Poojari Sushma Sundar", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Sandhya Santhosh", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Shaikh Afsha Ashraf", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Tiwari Rishabh Pawan", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Yadav Neha Rajesh", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 }
        ],
        semIII: [
          { rank: 1, name: "Naik Mansi Suhas Sneha", sgpi: 9.71, batch: "DEC 2020 Exam", universityRank: 5, instituteRank: 1 }
        ],
        semV: [
          { rank: 1, name: "Kewat Rahul Chhotelal", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Soni Priya Ajaykumar", sgpi: 10.0, batch: "DEC 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Fernandes Treyhan Kirsten", sgpi: 9.93, batch: "DEC 2020 Exam", universityRank: 2, instituteRank: 2 },
          { rank: 2, name: "Sane Dhanashree Sunil", sgpi: 9.93, batch: "DEC 2020 Exam", universityRank: 2, instituteRank: 2 }
        ]
      },
      summary: {
        batch: "BATCH 2018-2021",
        percentage: 94.87,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          title: "Result Analysis for Batch 2018-21",
          graduatingBatch: "BATCH 2018-2021",
          successfulGraduates: 117,
          firstDivisionGraduates: 111,
          percentage: 94.87,
          totalLabel: "Total Graduates",
          firstClassLabel: "First Class",
          firstDivisionLabel: "First Division %"
        }
      ],
      graphTitle: "Academic Graph (Batch 2018-21)",
      graphImg: defaultGraphImg
    },
"2019-20": {
      breadcrumb: "2019-20",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2019 (Dec '19) Examination",
          rows: [
            { semester: "SEMESTER - I (CBCGS)", appeared: 115, passed: 66, percent: 57.39 },
            { semester: "SEMESTER - III (CBCGS)", appeared: 118, passed: 87, percent: 73.72 },
            { semester: "SEMESTER - V (CBSGS)", appeared: 113, passed: 99, percent: 87.61 }
          ],
          overall: 72.81,
          passPercent: 72.81
        },
        firstHalf: {
          title: "First Half 2020 (May '20) Examination",
          rows: [
            { semester: "SEMESTER - II (CBCGS)", appeared: 115, passed: 114, percent: 99.15 },
            { semester: "SEMESTER - IV (CBCGS)", appeared: 118, passed: 118, percent: 100.0 },
            { semester: "SEMESTER - VI (CBSGS)", appeared: 113, passed: 113, percent: 100.0 }
          ],
          overall: 99.71,
          passPercent: 99.71
        }
      },
      toppers: {
        semII: [
          { rank: 1, name: "Ms. Shaikh Muskan", sgpi: 9.85, batch: "MAY 2020 Exam", universityRank: 2, instituteRank: 1 }
        ],
        semIV: [
          { rank: 1, name: "Mr. Kewat Rahul", sgpi: 10.0, batch: "MAY 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Mr. Parab Pritam", sgpi: 10.0, batch: "MAY 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Mr. Patel Uday", sgpi: 10.0, batch: "MAY 2020 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Ms. Tiwari Mayuri", sgpi: 10.0, batch: "MAY 2020 Exam", universityRank: 1, instituteRank: 1 }
        ],
        semVI: [
          { rank: 1, name: "Ms. Joshi Crina", sgpi: 9.23, batch: "MAY 2020 Exam", universityRank: 4, instituteRank: 1 }
        ],
        semI: [
          { rank: 1, name: "Shaikh Muskan Sadio Hafiza", sgpi: 9.38, batch: "DEC 2019 Exam", universityRank: 2, instituteRank: 1 }
        ],
        semIII: [
          { rank: 1, name: "Kore Rinkesh Sunil", sgpi: 9.04, batch: "DEC 2019 Exam", universityRank: 5, instituteRank: 1 }
        ],
        semV: [
          { rank: 1, name: "Joshi Crina Jitendra Shilpa", sgpi: 8.71, batch: "DEC 2019 Exam", universityRank: 5, instituteRank: 1 },
          { rank: 1, name: "Velankar Tanvi Dilip Deepali", sgpi: 8.71, batch: "DEC 2019 Exam", universityRank: 5, instituteRank: 1 }
        ]
      },
      summary: {
        batch: "BATCH 2017-2020",
        percentage: 67.26,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          title: "Result Analysis for Batch 2017-20",
          graduatingBatch: "BATCH 2017-2020",
          successfulGraduates: 113,
          firstDivisionGraduates: 76,
          percentage: 67.26,
         totalLabel: "Total Graduates",
          firstClassLabel: "First Class",
          firstDivisionLabel: "First Division %"
        }
      ],
      graphTitle: "Result Analysis for Batch 2017-20",
      graphImg: defaultGraphImg
    },
"2018-19": {
      breadcrumb: "2018-19",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2018 (Dec '18) Examination",
          rows: [
            { semester: "SEMESTER - I (CBCGS)", appeared: 120, passed: 73, percent: 60.83 },
            { semester: "SEMESTER - III (CBCGS)", appeared: 115, passed: 83, percent: 72.17 },
            { semester: "SEMESTER - V (CBSGS)", appeared: 110, passed: 103, percent: 93.63 }
          ],
          overall: 75.0,
          passPercent: 75.0
        },
        firstHalf: {
          title: "First Half 2019 (May '19) Examination",
          rows: [
            { semester: "SEMESTER - II (CBCGS)", appeared: 119, passed: 102, percent: 85.71 },
            { semester: "SEMESTER - IV (CBCGS)", appeared: 115, passed: 98, percent: 85.22 },
            { semester: "SEMESTER - VI (CBSGS)", appeared: 110, passed: 109, percent: 99.02 }
          ],
          overall: 89.83,
          passPercent: 89.83
        }
      },
      toppers: {
        semII: [
          { rank: 1, name: "Ms. Mayuri Tiwari", sgpi: 10.0, batch: "MAY 2019 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Mr. Rahul Kewat", sgpi: 9.54, batch: "MAY 2019 Exam", universityRank: 3, instituteRank: 2 }
        ],
        semIV: [
          { rank: 1, name: "Ms. Tanvi Velankar", sgpi: 9.18, batch: "MAY 2019 Exam", universityRank: 1, instituteRank: 1 }
        ],
        semVI: [
          { rank: 1, name: "Ms. Preeti Singh", sgpi: 9.32, batch: "MAY 2019 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Ms. Urvi Asolkar", sgpi: 8.93, batch: "MAY 2019 Exam", universityRank: 3, instituteRank: 2 }
        ],
        semI: [
          { rank: 1, name: "Mr. Rahul Kewat", sgpi: 9.54, batch: "DEC 2018 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Mr. Mayank Kothari", sgpi: 9.08, batch: "DEC 2018 Exam", universityRank: 3, instituteRank: 2 },
          { rank: 2, name: "Ms. Mayuri Tiwari", sgpi: 9.08, batch: "DEC 2018 Exam", universityRank: 3, instituteRank: 2 }
        ],
        semIII: [
          { rank: 1, name: "Ms. Sonia Deora", sgpi: 9.71, batch: "DEC 2018 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Ms. Crina Joshi", sgpi: 9.71, batch: "DEC 2018 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 2, name: "Mr. Suraj Patel", sgpi: 9.43, batch: "DEC 2018 Exam", universityRank: 3, instituteRank: 2 }
        ],
        semV: [
          { rank: 1, name: "Mr. Dhiraj Singh", sgpi: 9.57, batch: "DEC 2018 Exam", universityRank: 1, instituteRank: 1 },
          { rank: 1, name: "Ms. Preeti Singh", sgpi: 9.57, batch: "DEC 2018 Exam", universityRank: 1, instituteRank: 1 }
        ]
      },
      summary: {
        batch: "BATCH 2016-2019",
        percentage: 67.88,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          title: "Result Analysis for Batch 2016-19",
          graduatingBatch: "BATCH 2016-2019",
          successfulGraduates: 109,
          firstDivisionGraduates: 74,
          percentage: 67.88,
          totalLabel: "Total Graduates",
          firstClassLabel: "First Class",
          firstDivisionLabel: "First Division %"
        }
      ],
      graphTitle: "Academic Graph (Batch 2016-19)",
      graphImg: defaultGraphImg
    },
"2017-18": {
      breadcrumb: "2017-18",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2017 (Dec '17) Examination",
          rows: [
            { semester: "SEMESTER - I (CBCGS)", appeared: 120, passed: 58, percent: 48.3 },
            { semester: "SEMESTER - III (CBCGS)", appeared: 111, passed: 76, percent: 68.46 },
            { semester: "SEMESTER - V (CBSGS)", appeared: 104, passed: 99, percent: 95.19 }
          ],
          overall: 69.14,
          passPercent: 69.14
        },
        firstHalf: {
          title: "First Half 2018 (May '18) Examination",
          rows: [
            { semester: "SEMESTER - II (CBCGS)", appeared: 118, passed: 91, percent: 77.12 },
            { semester: "SEMESTER - IV (CBCGS)", appeared: 111, passed: 104, percent: 93.69 },
            { semester: "SEMESTER - VI (CBSGS)", appeared: 103, passed: 102, percent: 99.02 }
          ],
          overall: 89.18,
          passPercent: 89.18
        }
      },
      toppers: {
        semII: [
          { rank: 1, name: "Ms. Sonia Deora", sgpi: 9.69, batch: "MAY 2018 Exam", universityRank: 1 }
        ],
        semIV: [
          { rank: 1, name: "Ms. Poonam Bhagat", sgpi: 9.14, batch: "MAY 2018 Exam", universityRank: 3 }
        ],
        semI: [
          { rank: 1, name: "Mr. Suraj Patel", sgpi: 9.23, batch: "DEC 2017 Exam", universityRank: "-" }
        ],
        semIII: [
          { rank: 1, name: "Ms. Neha Pal", sgpi: 9.29, batch: "DEC 2017 Exam", universityRank: "-" }
        ],
        semV: [
          { rank: 1, name: "Mr. Divyam Nayak", sgpi: 9.29, batch: "DEC 2017 Exam", universityRank: "-" }
        ]
      },
      batchToppers: {
        title: "Topper Information (AY-2017-18)",
        subtitle: "Batch 2015-18",
        rows: [
          { rank: 1, description: "Rank 1", name: "Mr. Adithya Kanchan", score: 9.23 },
          { rank: 2, description: "Rank 2", name: "Ms. Anagha Patwardhan", score: 9.05 },
          { rank: 3, description: "Rank 3", name: "Ms. Mansi Shah", score: 8.97 },
          { rank: 4, description: "Rank 4", name: "Mr. Zoyein Patel", score: 8.83 },
          { rank: 5, description: "Rank 5", name: "Ms. Gomati Vysya", score: 8.67 }
        ]
      },
      summary: {
        batch: "BATCH 2015-2018",
        percentage: 73.53,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          title: "Result Analysis for Batch 2015-18",
          graduatingBatch: "BATCH 2015-2018",
          successfulGraduates: 102,
          firstDivisionGraduates: 75,
          percentage: 73.53,
          totalLabel: "Total Graduates",
          firstClassLabel: "First Class",
          firstDivisionLabel: "First Division %"
        }
      ],
      graphTitle: "Academic Graph (Batch 2015-18)",
      graphImg: "/Examination/Graph-2023-25.jpeg" 
    },
"2016-17": {
      breadcrumb: "2016-17",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2016 (Dec '16) Examination",
          rows: [
            { semester: "SEMESTER - I (CBCGS)", appeared: 120, passed: 57, percent: 47.5 },
            { semester: "SEMESTER - III (CBCGS)", appeared: 108, passed: 72, percent: 66.66 },
            { semester: "SEMESTER - V (CBSGS)", appeared: 99, passed: 70, percent: 70.7 }
          ],
          overall: 60.91,
          passPercent: 60.91
        },
        firstHalf: {
          title: "First Half 2017 (May '17) Examination",
          rows: [
            { semester: "SEMESTER - II (CBCGS)", appeared: 116, passed: 81, percent: 69.82 },
            { semester: "SEMESTER - IV (CBCGS)", appeared: 107, passed: 86, percent: 80.37 },
            { semester: "SEMESTER - VI (CBSGS)", appeared: 99, passed: 98, percent: 98.98 }
          ],
          overall: 81.99,
          passPercent: 81.99
        }
      },
      toppers: {
        semII: [
          { rank: 1, name: "Ms. Pooja Yadav", sgpi: 8.92, batch: "MAY 2017 Exam" },
          { rank: 1, name: "Ms. Preeti Singh", sgpi: 8.92, batch: "MAY 2017 Exam" }
        ],
        semIV: [
          { rank: 1, name: "Ms. Angha Patwardhan", sgpi: 8.96, batch: "MAY 2017 Exam" }
        ],
        semI: [
          { rank: 1, name: "Ms. Preeti Singh", sgpi: 9.85, batch: "DEC 2016 Exam" }
        ],
        semIII: [
          { rank: 1, name: "Mr. Aditya Kanchan", sgpi: 9.57, batch: "DEC 2016 Exam" }
        ],
        semV: [
          { rank: 1, name: "Ms. Bhavika Vartak", sgpi: 8.71, batch: "DEC 2016 Exam" }
        ]
      },
      batchToppers: {
        title: "Topper Information (AY-2016-17)",
        subtitle: "Batch 2014-17",
        rows: [
          { rank: 1, description: "Rank 1", name: "Ms. Bhavika Vartak", score: 8.92 },
          { rank: 2, description: "Rank 2", name: "Mr. Tanmay Sakpal", score: 8.38 },
          { rank: 3, description: "Rank 3", name: "Ms. Angha Baikar", score: 8.27 },
          { rank: 4, description: "Rank 3", name: "Mr. Yogesh Pawar", score: 8.13 },
          { rank: 5, description: "Rank 4", name: "Mr. Sandeep Kamat", score: 8.13 },
          { rank: 6, description: "Rank 5", name: "Ms. Krutika Hariharan", score: 8.1 }
        ]
      },
      summary: {
        batch: "BATCH 2014-2017",
        percentage: 65.21,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          title: "Result Analysis for Batch 2014-17",
          graduatingBatch: "BATCH 2014-2017",
          successfulGraduates: 92,
          firstDivisionGraduates: 60,
          percentage: 65.21,
          totalLabel: "Total Graduates",
          firstClassLabel: "First Class",
          firstDivisionLabel: "First Division %"
        }
      ],
      graphTitle: "Academic Graph (Batch 2014-17)",
      graphImg: "/Examination/Graph-2023-25.jpeg"
    },
"2015-16": {
      breadcrumb: "2015-16",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2015 (Dec '15) Examination",
          rows: [
            { semester: "SEMESTER - I (CBCGS)", appeared: 120, passed: 79, percent: 65.83 },
            { semester: "SEMESTER - III (CBCGS)", appeared: 102, passed: 63, percent: 61.76 },
            { semester: "SEMESTER - V (CBSGS)", appeared: 124, passed: 105, percent: 84.67 }
          ],
          overall: 71.25,
          passPercent: 71.25
        },
        firstHalf: {
          title: "First Half 2016 (May '16) Examination",
          rows: [
            { semester: "SEMESTER - II (CBCGS)", appeared: 113, passed: 80, percent: 70.79 },
            { semester: "SEMESTER - IV (CBCGS)", appeared: 102, passed: 79, percent: 77.45 },
            { semester: "SEMESTER - VI (CBSGS)", appeared: 124, passed: 124, percent: 100.0 }
          ],
          overall: 83.78,
          passPercent: 83.78
        }
      },
      toppers: {
        semII: [
          { rank: 1, name: "Ms. Angha Patwardhan", sgpi: 9.38, batch: "MAY 2016 Exam" }
        ],
        semIV: [
          { rank: 1, name: "Ms. Bavika Vartak", sgpi: 8.62, batch: "MAY 2016 Exam" }
        ],
        semI: [
          { rank: 1, name: "Mr. Aditya Kanchan", sgpi: 9.23, batch: "DEC 2015 Exam" }
        ],
        semIII: [
          { rank: 1, name: "Ms. Bhavika Vartak", sgpi: 9.57, batch: "DEC 2015 Exam" }
        ],
        semV: [
          { rank: 1, name: "Ms. Tripti Tiwari", sgpi: 9.129, batch: "DEC 2015 Exam" }
        ]
      },
      batchToppers: {
        title: "Topper Information (AY-2013-16)",
        subtitle: "Batch 2013-16",
        rows: [
          { rank: 1, description: "Rank 1", name: "Ms. Tripti Tiwari", score: 8.92 },
          { rank: 2, description: "Rank 2", name: "Mr. Chandrabhushan Dubey", score: 8.73 },
          { rank: 3, description: "Rank 3", name: "Ms. Reshma Tiwari", score: 8.72 },
          { rank: 4, description: "Rank 4", name: "Ms. Priyanka Kumari Singh", score: 8.54 },
          { rank: 5, description: "Rank 5", name: "Mr. Palak Shah", score: 8.51 }
        ]
      },
      summary: {
        batch: "BATCH 2013-2016",
        percentage: 66.38,
        improvement: 0
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          title: "Result Analysis for Batch 2013-16",
          graduatingBatch: "BATCH 2013-2016",
          successfulGraduates: 116,
          firstDivisionGraduates: 77,
          percentage: 66.38,
          totalLabel: "Total Graduates",
          firstClassLabel: "First Class",
          firstDivisionLabel: "First Division %"
        }
      ],
      graphTitle: "Academic Graph (Batch 2013-16)",
      graphImg: "/Examination/Graph-2023-25.jpeg"
    },
    "2024-25": {
      breadcrumb: "2024-25",
      semesterAnalysis: {
        secondHalf: {
          title: "Second Half 2024 (Dec '24) Examination",
          rows: [
            { semester: "SEMESTER - I (2 yr course)", appeared: 188, passed: 106, percent: 56.38 },
            { semester: "SEMESTER - III (2 yr course)", appeared: 185, passed: 133, percent: 71.89 }
          ],
          overall: 64.08, // Calculated: (106+133)/(188+185)
          passPercent: 64.08
        },
        firstHalf: {
          title: "First Half 2025 (Jun '25) Examination",
          rows: [
            { semester: "SEMESTER - II (2 yr course)", appeared: 188, passed: 157, percent: 84.04 },
            { semester: "SEMESTER - IV (2 yr course)", appeared: 185, passed: 183, percent: 98.91 }
          ],
          overall: 91.15, // Calculated: (157+183)/(188+185)
          passPercent: 91.15
        }
      },
      toppers: {
        semI: [
          { rank: 1, name: "Muskan Akbar Ali Gulnaz", sgpi: 9.62, batch: "2021-23" },
          { rank: 2, name: "Jain Shreya Mahendra Alka", sgpi: 9.33, batch: "2021-23" }
        ],
        semIII: [
          { rank: 1, name: "Shahu Pooja Jitendra", sgpi: 9.85, batch: "2021-23" },
          { rank: 2, name: "Singh Lacky Shivkumar", sgpi: 9.40, batch: "2021-23" }
        ]
      },
      summary: {
        batch: "BATCH 2021-2023",
        percentage: 81.76,
        improvement: 4.5 
      },
      graduatingBatchPerformance: [
        {
          srNo: 1,
          graduatingBatch: "BATCH 2021-2023",
          successfulGraduates: 170,
          firstDivisionGraduates: 139,
          percentage: 81.76
        }
      ],
      graphTitle: "Result Analysis Graph for Batch 2021-23",
      graphImg: "/Examination/Graph-2023-25.jpeg" 
    }
  };

  const years = ["2024-25", "2023-24", "2022-23", "2021-22", "2020-21", "2019-20", "2018-19", "2017-18", "2016-17", "2015-16"].filter((year) => resultData[year]);
  const [activeYear, setActiveYear] = useState(years[0]);
  const currentData = resultData[activeYear];
  const topperSections = Object.entries(currentData.toppers);
  const showAcademicExcellence = Number(currentData.summary.improvement) > 0 && activeYear !== "2024-25";

  return (
    <div className="ra-page-root">
      <Navbar />
      <PageHeader
        title="Result Analysis"
        crumbs={[
          { label: 'Home', href: '/' },
          { label: `Result Analysis Academic Year ${activeYear}` },
        ]}
      />
      
      <div className="ra-dashboard-wrapper">
        <div className="ra-main-container">
          
          {/* Semester-wise Analysis Section */}
          <div className="ra-section-header-row">
            <div className="ra-section-title-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--ra-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 20V10"></path><path d="M12 20V4"></path><path d="M6 20v-6"></path></svg>
              <div className="ra-section-title">Semester-wise Analysis</div>
            </div>
 
          </div>

          <div className="ra-year-selector">
            {years.map((year) => (
              <button 
                key={year} 
                className={`ra-year-pill ${activeYear === year ? 'ra-active' : ''}`}
                onClick={() => setActiveYear(year)}
              >
                {year}
              </button>
            ))}
          </div>

          <div className="ra-semester-grid">
            {/* Second Half Card */}
            <div className="ra-card">
              <div className="ra-card-header ra-blue-bg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                {currentData.semesterAnalysis.secondHalf.title}
              </div>
              <table className="ra-table">
                <thead>
                  <tr>
                    <th>Semester</th>
                    <th>Appeared</th>
                    <th>Passed</th>
                    <th>Institute %</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.semesterAnalysis.secondHalf.rows.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.semester}</td>
                      <td>{row.appeared}</td>
                      <td>{row.passed}</td>
                      <td>
                        <div className="ra-progress-cell">
                          <span>{row.percent}%</span>
                          <div className="ra-progress-bar">
                            <div style={{ width: `${row.percent}%`, background: '#5865F2' }}></div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="ra-card-footer-stats">
                <div className="ra-stat-box">
                  <div className="ra-stat-icon-wrap ra-blue">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
                  </div>
                  <div className="ra-stat-info">
                    <div className="ra-stat-info-label">Overall Result</div>
                    <div className="ra-stat-info-val">{currentData.semesterAnalysis.secondHalf.overall}%</div>
                    <div className="ra-stat-progress"><div className="ra-stat-progress-fill" style={{width: `${currentData.semesterAnalysis.secondHalf.overall}%`, background: '#5865F2'}}></div></div>
                  </div>
                </div>
                <div className="ra-stat-box">
                  <div className="ra-stat-icon-wrap ra-blue">
                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                  </div>
                  <div className="ra-stat-info">
                    <div className="ra-stat-info-label">Pass Percentage</div>
                    <div className="ra-stat-info-val">{currentData.semesterAnalysis.secondHalf.passPercent}%</div>
                    <div className="ra-stat-progress"><div className="ra-stat-progress-fill" style={{width: `${currentData.semesterAnalysis.secondHalf.passPercent}%`, background: '#8EA1FF'}}></div></div>
                  </div>
                </div>
              </div>
            </div>

            {/* First Half Card */}
            <div className="ra-card">
              <div className="ra-card-header ra-green-bg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                {currentData.semesterAnalysis.firstHalf.title}
              </div>
              <table className="ra-table">
                <thead>
                  <tr>
                    <th>Semester</th>
                    <th>Appeared</th>
                    <th>Passed</th>
                    <th>Institute %</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.semesterAnalysis.firstHalf.rows.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.semester}</td>
                      <td>{row.appeared}</td>
                      <td>{row.passed}</td>
                      <td>
                        <div className="ra-progress-cell">
                          <span>{row.percent}%</span>
                          <div className="ra-progress-bar">
                            <div style={{ width: `${row.percent}%`, background: '#10B981' }}></div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="ra-card-footer-stats">
                <div className="ra-stat-box">
                  <div className="ra-stat-icon-wrap ra-green">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path><path d="M4 22h16"></path><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path></svg>
                  </div>
                  <div className="ra-stat-info">
                    <div className="ra-stat-info-label">Overall Result</div>
                    <div className="ra-stat-info-val">{currentData.semesterAnalysis.firstHalf.overall}%</div>
                    <div className="ra-stat-progress"><div className="ra-stat-progress-fill" style={{width: `${currentData.semesterAnalysis.firstHalf.overall}%`, background: '#10B981'}}></div></div>
                  </div>
                </div>
                <div className="ra-stat-box">
                  <div className="ra-stat-icon-wrap ra-blue">
                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
                  </div>
                  <div className="ra-stat-info">
                    <div className="ra-stat-info-label">Pass Percentage</div>
                    <div className="ra-stat-info-val">{currentData.semesterAnalysis.firstHalf.passPercent}%</div>
                    <div className="ra-stat-progress"><div className="ra-stat-progress-fill" style={{width: `${currentData.semesterAnalysis.firstHalf.passPercent}%`, background: '#10B981'}}></div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Top Performers Section */}
          <div className="ra-section-header-row">
            <div className="ra-section-title-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path><path d="M4 22h16"></path><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path></svg>
              <div className="ra-section-title">Topper Information - A.Y. {activeYear}</div>
            </div>

          </div>

          <div className={`ra-performers-wrapper ${currentData.graduatingBatchPerformance ? 'ra-performers-with-sidecard' : ''}`}>
            <div className="ra-toppers-left-grid">
              {topperSections.map(([semesterKey, toppers]) => {
                const meta = topperMeta[semesterKey] || topperMeta.semI;
                const isBlueTheme = meta.theme === 'blue';

                return (
                  <div className="ra-topper-group" key={semesterKey}>
                    <div className={`ra-topper-group-title ${isBlueTheme ? 'ra-title-blue' : 'ra-title-green'}`}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                      <div className="ra-group-text">{meta.title}</div>
                    </div>
                    <div className="ra-topper-cards-container">
                      {toppers.map((topper, idx) => (
                        <div className="ra-topper-card" key={`${semesterKey}-${idx}`}>
                          <div className="ra-medal-container">
                            <div className={`ra-medal-circle ${idx === 0 ? 'ra-medal-gold' : 'ra-medal-silver'}`}>
                              {topper.rank}
                            </div>
                            <div className="ra-medal-ribbons">
                              {isBlueTheme ? (
                                <>
                                  <div className={`ra-ribbon ${idx === 0 ? 'ra-ribbon-blue-light' : 'ra-ribbon-blue-dark'}`}></div>
                                  <div className={`ra-ribbon ${idx === 0 ? 'ra-ribbon-blue-dark' : 'ra-ribbon-blue-light'}`}></div>
                                </>
                              ) : (
                                <>
                                  <div className="ra-ribbon ra-ribbon-green-light"></div>
                                  <div className="ra-ribbon ra-ribbon-green-dark" style={{ background: '#10B981' }}></div>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="ra-topper-info">
                            <div className={`ra-topper-badge ${isBlueTheme ? 'ra-badge-blue' : 'ra-badge-green'}`}>{meta.badge}</div>
                            <div className="ra-topper-rank-text">Rank {topper.rank}</div>
                            <div className="ra-topper-name" style={{ fontSize: '15px', fontWeight: 700, color: meta.nameColor, marginBottom: '6px' }}>{topper.name}</div>
                            <div className="ra-topper-details">
                              <div className="ra-detail-line">SGPI: {topper.sgpi}</div>
                              <div className="ra-detail-line">Exam: {topper.batch}</div>
                              {topper.universityRank && <div className="ra-detail-line">University Rank: {topper.universityRank}</div>}
                              {topper.instituteRank && <div className="ra-detail-line">Institute Rank: {topper.instituteRank}</div>}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            {currentData.graduatingBatchPerformance && (
        <div className="ra-performers-side-panel">
  <div className="ra-graduating-side-group">
    <div className="ra-graduating-side-title">
      <div className="ra-title-icon-box">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
      </div>
      <div className="ra-group-text">Graduating Batch Performance</div>
    </div>

    <div className={`ra-graduating-showcase ${activeYear === '2021-22' ? 'ra-graduating-showcase-stacked' : ''}`}>
      {currentData.graduatingBatchPerformance.map((row) => (
        <div className="ra-result-glass-card" key={`${activeYear}-${row.srNo}`}>
          <div className="ra-card-glow"></div>
          
          <div className="ra-mini-header">
            <div className="ra-result-mini-title">{row.title || `Result Analysis ${activeYear}`}</div>
            <div className="ra-result-mini-batch">{row.graduatingBatch}</div>
          </div>

          <div className="ra-mini-body">
            <div className="ra-stats-left">
              <div className="ra-stat-item">
                <span className="ra-stat-label">{row.totalLabel || 'Total Graduates'}</span>
                <span className="ra-stat-value">{row.successfulGraduates}</span>
              </div>
              <div className="ra-stat-item">
                <span className="ra-stat-label">{row.firstClassLabel || 'First Class'}</span>
                <span className="ra-stat-value">{row.firstDivisionGraduates}</span>
              </div>
              <div className="ra-stat-item ra-stat-highlight">
                <span className="ra-stat-label">{row.firstDivisionLabel || 'First Division %'}</span>
                <span className="ra-stat-value-large">{row.percentage}%</span>
              </div>
            </div>

            <div className="ra-stats-right">
              <div className="ra-progress-circle-wrapper">
                <svg viewBox="0 0 120 120" className="ra-mini-svg">
                  <defs>
                    <linearGradient id="circleGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#5865F2" />
                      <stop offset="100%" stopColor="#8EA1FF" />
                    </linearGradient>
                  </defs>
                  <circle className="ra-mini-bg" cx="60" cy="60" r="48" />
                  <circle
                    className="ra-mini-fill"
                    cx="60"
                    cy="60"
                    r="48"
                    stroke="url(#circleGrad)"
                    style={{
                      strokeDasharray: `${row.percentage * 3.01} 301.6`
                    }}
                  />
                </svg>
                <div className="ra-circle-inner-text">
                   <div className="ra-percent-num">{row.percentage}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
            )}

            {showAcademicExcellence && (
              <div className="ra-excellence-card">
                 <div className="ra-exc-title">ACADEMIC EXCELLENCE</div>
                 <div className="ra-exc-percentage">{currentData.summary.percentage}%</div>
                 <div className="ra-exc-subtitle">First Division Rate</div>
                 <div className="ra-exc-badge-pill">
                   <div className="ra-exc-arrow">↑</div>
                   <div className="ra-pill-text">{currentData.summary.improvement}% from last year</div>
                 </div>

                 <div className="ra-exc-chart-container">
                   <svg viewBox="0 0 36 36" className="ra-donut-svg">
                     <path
                       className="ra-donut-bg"
                       d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                     />
                     <path
                       className="ra-donut-fill"
                       strokeDasharray={`${currentData.summary.percentage}, 100`}
                       d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                     />
                   </svg>
                   <div className="ra-exc-chart-center">
                     <div className="ra-exc-chart-val">{currentData.summary.improvement}%</div>
                     <div className="ra-exc-chart-lbl">Improvement</div>
                   </div>
                 </div>
              </div>
            )}
          </div>

          {currentData.batchToppers && (
            <>
              <div className="ra-section-header-row">
                <div className="ra-section-title-wrap">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path><path d="M4 22h16"></path><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path></svg>
                  <div className="ra-section-title">{currentData.batchToppers.title}</div>
                </div>
              </div>

              <div className="ra-card">
                <div className="ra-card-header ra-green-bg">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 15l-3.5 2 1-4-3-2.5 4-.5L12 6l1.5 4 4 .5-3 2.5 1 4z"></path></svg>
                  {currentData.batchToppers.subtitle}
                </div>
                <table className="ra-table">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Description</th>
                      <th>Name</th>
                      <th>CGPA</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.batchToppers.rows.map((row) => (
                      <tr key={row.rank}>
                        <td>{row.rank}</td>
                        <td>{row.description}</td>
                        <td>{row.name}</td>
                        <td>{row.score}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          <div className="ra-card">
            <div className="ra-graph-header-controls">
              <div className="ra-chart-tabs">
                <button className="ra-chart-tab ra-active">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                  <div className="ra-tab-text">Bar Chart</div>
                </button>
              </div>
              <div className="ra-graph-title-center">{currentData.graphTitle}</div>
            </div>
            
            <div className="ra-graph-container">
              <img 
                src={currentData.graphImg || defaultGraphImg} 
                alt="Batch Performance Analytics" 
                className="ra-graph-img" 
              />
            </div>
            <div className="ra-graph-footer-minimal">
              Institute Pass Percentage Trend: Last 5 Academic Years
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResultAnalysis1;
